<template>
  <form-wrapper :title="option.title" :description="option.description" @submit="submit()" @previous="previous()"
    :isFirst="isFirst" :isLast="isLast" :disabled="isSaving">
    <dl>
      <dt>Your Name</dt>
      <dd>{{ student.firstName }} {{ student.lastName }}</dd>

      <dt>Your Email</dt>
      <dd>{{ student.asuemailAddress }}</dd>

      <dt>Your Current Programs</dt>
      <dd>
        <ul>
          <li v-if="activePlan">
            {{ activePlan.academicPlan }} - {{ activePlan.academicPlanDescription }}
          </li>
        </ul>
      </dd>
    </dl>

    <b-form-group label="What semester are you completing your internship?" label-for="semester"
      label-class="control-label opportunity-form-label required"
      :class="{ 'invalid-group': $v.studentOpportunity.opportunity.termId.$error }">
      <b-form-select v-model="studentOpportunity.opportunity.termId" :options="terms" id="semester" value-field="termId"
        text-field="description" :disabled="studentOpportunity.active"
        :class="{ 'is-invalid': $v.studentOpportunity.opportunity.termId.$error }"></b-form-select>
      <span class="span-feedback invalid-feedback" v-if="$v.studentOpportunity.opportunity.termId.$error">You must
        select
        a semester.</span>
    </b-form-group>

    <b-form-group label="" label-class="font-weight-bold">
      <b-form-checkbox v-model="slpaStudent"
        :disabled="studentOpportunity.studentOpportunityId !== undefined && studentOpportunity.studentOpportunityId !== 0 && studentOpportunity.studentOpportunityId !== null && studentOpportunity.studentOpportunityId !== ''"
        stacked>I am an admitted SLPA student on the Tempe campus (NOTE: Only select this box if you received admission
        to
        the SLPA program)</b-form-checkbox>
    </b-form-group>

  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formWrapper from "./form-wrapper";
import termsApi from "../../../api/terms";
import studentsApi from "../../../api/students";
import { required } from "vuelidate/lib/validators";
import * as _ from "lodash";

export default {
  data() {
    return {
      terms: [],
      student: {},
      termId: null,
      isSaving: false,
      slpaStudent: false
    };
  },

  validations: {
    studentOpportunity: {
      opportunity: {
        termId: {
          required
        }
      }
    }
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    asuriteId: {
      type: String,
      required: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId,
      studentOpportunity: state => state.additionalMaterials.studentOpportunity
    }),
    currentPlans() {
      var currentTerm = this.terms[0];
      var filteredPlans = _.filter(this.student.studentPlans, plan => {
        return plan.termCode == currentTerm.termCode;
      });
      return filteredPlans;
    },
    activePlan() {
      if (this.student) {
        const studentPlans = this.student.studentPlans;
        if (this.student.studentPlans) {
          const latestTerm = studentPlans.sort((a, b) =>
            b.termCode.localeCompare(a.termCode)
          )[0].termCode;

          return this.student.studentPlans.find(
            plan => plan.termCode === latestTerm && plan.primaryRecord === "Y"
          );
        }
      }
    }
  },

  methods: {
    ...mapActions("additionalMaterials", [
      "setStudentOpportunity",
      "setStudentOpportunityId"
    ]),
    ...mapActions("pip", ["createShell", "updateShell"]),
    submit: function () {
      this.$v.$touch();
      var that = this;

      if (!this.$v.$invalid) {
        this.isSaving = true;
        this.studentOpportunity.asuriteId = this.student.asuriteId;
        if (this.studentOpportunity.studentOpportunityId) {
          this.updateShell(this.studentOpportunity)
            .then(response => {
              that.setStudentOpportunity(this.studentOpportunity);
              this.setStudentOpportunityId(
                this.studentOpportunity.studentOpportunityId
              );
              that.$emit("submitted");
            })
            .finally(() => {
              this.isSaving = false;
            });
        } else {
          var category = "PIP";
          if (this.slpaStudent) {
            category = "PIP - SLPA";
          }
          this.createShell({
            studentOpportunity: this.studentOpportunity,
            category: category
          })
            .then(response => {
              that.setStudentOpportunity(response.data);
              this.setStudentOpportunityId(
                this.studentOpportunity.studentOpportunityId
              );
              that.$emit("submitted");
            })
            .finally(() => {
              this.isSaving = false;
            });
        }
      }
    },
    previous: function () {
      this.$emit("previous");
    }
  },

  created() {
    var that = this;

    termsApi
      .getCurrentAndFutureTerms()
      .then(function (response) {
        that.terms = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    studentsApi
      .getStudentByAsuriteId(this.asuriteId)
      .then(function (response) {
        that.student = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
